// extracted by mini-css-extract-plugin
export default {"title":"index-module_title_nYKoA","full":"index-module_full_kdzfl","textPart":"index-module_textPart_g3Ue-","addonAfter":"index-module_addonAfter_HtxuO"};